// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-ecommerce-layout',
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    computed: {
        getStickyMenu() {
            return this.$host.store.get("session").stickyMenu;
        },
        hasUser() {
            return this.$host.store.get("session").isAuthenticated;
        },
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        userDisplayName() {
            if (!this.currentUser) {
                return '';
            }
            return this.currentUser.displayName;
        },
        userSubTitle() {
            if (!this.currentUser) {
                return '';
            }
            return this.currentUser.subTitle;
        },
        userInitials() {
            if (!this.currentUser) {
                return '';
            }
            return this.currentUser.initials;
        },
        mainMenuEntriesLeft() {
            return this.$host.store.getter("navigation/getMenu", "MAIN").filter(e => e.alignment == 0);
        },
        mainMenuEntriesRight() {
            return this.$host.store.getter("navigation/getMenu", "MAIN").filter(e => e.alignment == 1);
        },
        footerMenuEntriesRight() {
            return this.$host.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    },
    methods: {
        onMobileNavToogle(event) {
            event.stopPropagation();
            this.$host.pageMeta.toogleMobileNav();
        },
    },
});
// #endregion
